import React from 'react';
import { zIndex } from '../../design-system/tokens';
import Button from '../ui/Button';

const STEPS = [
  'Pick a game',
  'Join a challenge',
  'Claim challenge earnings',
];

/**
 * Non-blocking welcome ticket — slides in from the right.
 * App remains fully interactive behind it (no modal scrim).
 */
export default function GuestWelcomeTicket({ open, onDismiss }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-y-0 right-0 flex items-start justify-end p-4 sm:p-6 pointer-events-none"
      style={{ zIndex: zIndex.modal }}
      role="complementary"
      aria-label="Welcome to Lockbox"
    >
      <div
        className="guest-welcome-ticket pointer-events-auto w-[min(100%,18.5rem)] text-left"
        style={{ marginTop: 'max(5.5rem, calc(var(--safe-top, 0px) + 4.5rem))' }}
      >
        <div className="relative rounded-2xl rounded-r-md border border-emerald-500/35 bg-gray-950/95 shadow-[0_20px_50px_rgba(0,0,0,0.55)] backdrop-blur-md overflow-hidden">
          <div
            className="absolute left-0 top-0 bottom-0 w-3 border-r border-dashed border-emerald-500/25 bg-emerald-500/[0.06]"
            aria-hidden
          />

          <div className="pl-5 pr-4 py-4 sm:py-5">
            <button
              type="button"
              onClick={onDismiss}
              aria-label="Close welcome guide"
              className="absolute top-3 right-3 w-8 h-8 rounded-lg border border-white/10 text-gray-400 hover:text-white hover:border-emerald-500/40 bg-black/40 text-lg leading-none"
            >
              ×
            </button>
            <div className="flex items-center gap-2 mb-3">
              <span className="text-[9px] font-black uppercase tracking-[0.28em] text-emerald-400/90">
                Guest pass
              </span>
              <span className="h-px flex-1 bg-emerald-500/20" aria-hidden />
            </div>

            <h2 className="text-base font-black uppercase tracking-tight text-white mb-3">
              Welcome to Lockbox
            </h2>

            <ul className="space-y-2 mb-4">
              {STEPS.map((step, i) => (
                <li key={step} className="flex items-start gap-2.5 text-sm text-gray-300">
                  <span className="shrink-0 w-5 h-5 rounded-md bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center text-[10px] font-black text-emerald-400">
                    {i + 1}
                  </span>
                  <span className="font-semibold leading-snug pt-0.5">{step}</span>
                </li>
              ))}
            </ul>

            <Button type="button" fullWidth onClick={onDismiss}>
              Got it
            </Button>

            <p className="mt-3 text-[9px] font-bold uppercase tracking-widest text-gray-500 text-center">
              Help → Welcome Guide or How to Play anytime
            </p>
          </div>

          {/* Ticket stub notch */}
          <div
            className="absolute -left-1.5 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-black border border-emerald-500/20"
            aria-hidden
          />
        </div>
      </div>
    </div>
  );
}
